<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Data NOC</h4>
					<button class="float-right btn btn-primary shadow mt-2"
					        v-on:click="formApplicationActive=!formApplicationActive">Tambah Data NOC Baru
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formApplicationActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">Form Data NOC Baru</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">NOC <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.noc"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">ID NOC <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.id_noc"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Alamat <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.addres"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Longitude <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.longitude"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Latitude <span style="color:red;">*</span></label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newApplication.latitude"/>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="newApplicationSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Data NOC Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorNewApplication">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">{{ createErrorMessage }}</p>
										</div>
										<div v-for="err in errorApplicationList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1 w-100">
												{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewApplication">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan Data, Tunggu Sebentar</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="saveNewApplication">Submit
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
						<datatable :currentIdx="currentPage" :datas="nocs" :structure="applicationTableStructure"
						           :init="loadData"
						           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
						           use-seeker seeker-url="/api/master/seeker/nocs"
						           @refetch="(row)=>{rowLimit=row;getApplications()}"
						           @searching="(val)=>!val.status?getApplications():nocs=val.data">
						<template #customcell={obj,index}>
							<td v-if="isMobile" class="py-3">
								<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<br>
											<b class="py-0 mx-0" style="font-size:20pt">
												{{ obj.noc ? obj.noc : "-" }}
											</b>
										</div>
										<hr class="my-1">
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">ID NOC :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.id_noc ? obj.id_noc : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Alamat :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.address ? obj.address : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Longitude :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.longitude ? obj.longitude : "-" }}
											</b>
										</div>
									</li>
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<small class="my-0 py-0">Latitude :</small>
											<br>
											<b class="py-0 mx-0" style="font-size:10pt">
												{{ obj.latitude ? obj.latitude : "-" }}
											</b>
										</div>
									</li>
									<hr class="my-1">
									<li class="mt-2">
										<div class="text-left mx-3 pt-0">
											<b-button v-b-modal.modal-edit-application class="btn btn-info mr-2"
											          v-on:click="selectedApplication=index;dataEdit=Object.assign({},obj)">
												<b-icon icon="pencil-square"></b-icon>
											</b-button>
											<b-button v-b-modal.modal-delete
											          v-on:click="deleteId=obj.id;itemToDelete=obj"
											          class="btn btn-danger">
												<b-icon icon="trash"></b-icon>
											</b-button>
										</div>
									</li>
								</ul>
							</td>
							<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1 }}</td>
							<td v-if="!isMobile">{{ obj.noc ? obj.noc : "-" }}</td>
							<td v-if="!isMobile">{{ obj.id_noc ? obj.id_noc : "-" }}</td>
							<td v-if="!isMobile">{{ obj.address ? obj.address : "-" }}</td>
							<td v-if="!isMobile">{{ obj.longitude ? obj.longitude : "-" }}</td>
							<td v-if="!isMobile">{{ obj.latitude ? obj.latitude : "-" }}</td>
							<td v-if="!isMobile">
								<b-button v-b-modal.modal-edit-application class="btn btn-info mr-2 mb-1"
								          v-on:click="selectedApplication=index;dataEdit=Object.assign({},obj)">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj" 
								          class="btn btn-danger mr-2 mb-1">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal no-close-on-esc content-class="m-0" id="modal-edit-application" title="Edit NOC"
				         scrollable no-close-on-backdrop size="lg" @hide="editModalClose">
					<b-container fluid v-if="!loadData&&nocs.length>0">
						<b-row class="mt-3 pt-1" v-if="nocs[selectedApplication]!=undefined">
							<b-col cols="12" class="my-1">
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">NOC</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="nocs[selectedApplication].noc"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">ID NOC</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="nocs[selectedApplication].id_noc"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Alamat</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="nocs[selectedApplication].address"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Longitude</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="nocs[selectedApplication].longitude"/>
							</b-col>
							<b-col cols="12" md="6" lg="4">
								<label class="d-block">Latitude</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="nocs[selectedApplication].latitude"/>
							</b-col>

							<b-col cols="12" class="my-3 text-right" v-if="updateApplicationState">
								<div class="d-flex align-items-center justify-content-start">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan Data, Tunggu Sebentar</strong>
								</div>
							</b-col>
							<div class="col-12 mt-3" v-if="updateApplicationSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-success" role="alert">
										Berhasil Update Data NOC
									</div>
								</div>
							</div>
							<div class="col-12 mt-3" v-if="errorApplicationSaved">
								<div class="w-100 align-items-center justify-content-start">
									<div class="alert alert-danger" role="alert">
										Gagal Update Data NOC
									</div>
								</div>
							</div>
							<b-col cols="12" class="my-3 text-right">
								<button class="btn btn-info" v-on:click="updateApplicationData">Simpan</button>
							</b-col>
						</b-row>
					</b-container>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<b-button class="btn btn-secondary mr-2"
							          @click="(!updateApplicationState&&!updateApplicationState)?$bvModal.hide('modal-edit-application'):''">
								Tutup
							</b-button>
							<!-- <button class="btn btn-info" v-on:click="updateClientData">submit</button> -->
						</div>
					</template>
				</b-modal>
				<modal-delete url="/api/master/nocs/" @read="()=>{console.log('modal ready')}"
				              @result="deleteResult" :targetid="deleteId">
					Yakin Ingin Menghapus Data Dengan Detail Berikut :<br>
					<ul>
						<li>NOC: {{ itemToDelete.noc }}</li>
					</ul>
				</modal-delete>


			</div>
		</div>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			//step 1 edit
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			isMobile: false,
			dataEdit: null,
			deleteId: 0,
			createErrorMessage: "Gagal Menyimpan Data Pelanggan Baru.",
			errorMessages: [],
			itemToDelete: {},
			nocs: [],
			searchValue: "",
			loadData: true,
			savingNewApplication: false,
			errorNewApplication: false,
			errorApplicationList: [],
			errorApplicationSaved: false,
			newApplicationSaved: false,
			updateApplicationState: false,
			updateApplicationSaved: false,
			selectedApplication: 0,
			selectedTab: 0,
			updateApplicationCol: 6,
			newApplication: {
				noc: ""
			},
			formApplicationActive: false,
			applicationTableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "NOC", key: null},
				{label: "ID NOC", key: null},
				{label: "Alamat", key: null},
				{label: "Longitude", key: null},
				{label: "Latitude", key: null},
				{label: "Tindakan", key: null}
			]
		};
	},
	created() {
		console.clear();
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		console.log("user page");
		this.getApplications();
		this.isMobile = this.$isMobile;
		window.addEventListener("resize", () => {
			console.log("screen update");
			this.isMobile = screen.width < 768;
		});
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
	},
	methods: {
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = parseInt(myParams);
			var newUrl = this.$baseUrl + "/api/master/nocs?limit=" + this.rowLimit + "&page=" + myParams;
			this.getApplications(newUrl);
		},
		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getApplications();
			}
		},
		getApplications(url = (this.$baseUrl + "/api/master/nocs?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log("get di sini");
				console.log(result.data.data.data);
				this.prevUrl = result.data.data.prev_page_url;
				this.nextUrl = result.data.data.next_page_url;
				this.currentPage = result.data.data.current_page;
				this.perPage = parseInt(result.data.data.per_page);
				this.nocs = result.data.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		saveNewApplication() {
			this.savingNewApplication = true;
			this.errorNewApplication = false;
			console.log(this.newApplication);
			axios.post(
				this.$baseUrl + "/api/master/nocs",
				{
					"noc": this.newApplication.noc,
					"id_noc": this.newApplication.noc,
					"address": this.newApplication.noc,
					"longitude": this.newApplication.noc,
					"latitude": this.newApplication.noc
				},
				{
					"headers":
						{
							"Authorization": "Bearer " + localStorage.getItem("accessToken")
						}
				}
			).then((result) => {
				console.log(result);
				this.getApplications();
				this.savingNewApplication = false;
				this.newApplicationSaved = true;
				setTimeout(() => {
					this.newApplicationSaved = false;
					this.formApplicationActive = false;
				}, 1000);

			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err.response);
				this.errorApplicationList = [];
				this.errorApplicationList = Object.values(err.response.data.errors);
				console.log(this.errorApplicationList);
				this.errorNewApplication = true;
				this.savingNewApplication = false;
			});
		},
		newUsernameChange() {
			this.newApplication.password = this.newApplication.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk user id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newApplication.role = newValue;
		},
		setNewClientId(newId) {
			this.newApplication.clientId = newId;
			console.log(this.newApplication.clientId);
		},

		updateApplicationData() {
			console.log("updating data");
			this.updateApplicationState = true;
			this.errorApplicationSaved = false;
			axios.put(this.$baseUrl + "/api/master/nocs/" + this.nocs[this.selectedApplication].id,{
			          noc:this.nocs[this.selectedApplication].noc,
					  id_noc:this.nocs[this.selectedApplication].id_noc,
					  address:this.nocs[this.selectedApplication].address,
					  longitude:this.nocs[this.selectedApplication].longitude,
					  latitude:this.nocs[this.selectedApplication].latitude
					  },
			          {
				          "headers": {
					          "Authorization": "Bearer " + localStorage.getItem("accessToken")
				          }
			          }
			).then((result) => {
				if (result.status == 200) {
					this.updateApplicationState = false;
					this.updateApplicationSaved = true;
					//step 4 edit
					this.dataEdit = this.nocs[this.selectedApplication];
					setTimeout(() => {
						this.updateApplicationSaved = false;
						this.$bvModal.hide("modal-edit-application");
					}, 1000);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updateApplicationState = false;
				this.errorApplicationSaved = true;
				console.log(err.response);
			});
		},
		editModalClose(mdl) {
			//step 2 edit
			this.$set(this.nocs, this.selectedApplication, this.dataEdit);
			//step 3 edit
			this.dataEdit = Object.assign({}, null);
			if (this.updateApplicationState) {
				console.log("updating");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-edit-application");
			}
		},
		deleteModalClose(mdl) {
			if (this.deleteUserState) {
				console.log("deleting");
				mdl.preventDefault();
			} else {
				console.log("closing");
				mdl.hide("modal-delete-user");
			}
		},

		deleteClientData() {
			console.log("deleting data");
			this.deleteUserState = true;
			axios.delete(this.$baseUrl + "/api/master/bank/" + this.users[this.selectedToDelete].id, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				if (result.status == 200) {
					this.deleteUserState = false;
					this.userDeleted = true;
					this.users.splice(this.selectedToDelete, 1);

					setTimeout(() => {
						this.$bvModal.hide("modal-delete-user");
						this.userDeleted = false;
					}, 1500);
					console.log("yaya berhasil");
				}
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.deleteUserState = false;
				this.failDeleteUser = true;
				setTimeout(() => {
					this.failDeleteUser = false;
				}, 1500);
				console.log(err);
			});
		}
	}
};
</script>
<style scoped>
::v-deep .modal-content {
	margin: -3.25rem auto;
}

.btn {
	padding: 2px 6px;
}
</style>
